import { frontendURL } from '../../../../helper/URLHelper';

const TicketsWrapper = () => import('../Tickets.vue');
const TicketsView = () => import('./TicketView.vue');

const Index = () => import('./Index.vue');
const Organization = () => import('./Organization.vue');
export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/requests'),
      meta: {
        permissions: [
          'end_user_view_only',
          'end_user_view_all',
          'end_user_executive',
        ],
      },
      component: TicketsWrapper,
      props: {
        headerTitle: 'CHATBOT_SETTINGS.TITLE',
        icon: 'bot',
        showNewButton: false,
      },
      children: [
        {
          path: '',
          redirect: 'list',
        },
        {
          path: 'list',
          name: 'list_requests',
          meta: {
            permissions: [
              'end_user_view_only',
              'end_user_view_all',
              'end_user_executive',
            ],
          },
          component: Index,
        },
        {
          path: 'organization',
          name: 'list_organization',
          meta: {
            permissions: ['end_user_view_all'],
          },
          component: Organization,
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/requests/:conversation_id'),
      name: 'requests_conversation',
      meta: {
        permissions: ['end_user_view_all'],
      },
      component: TicketsView,
      props: route => {
        return { inboxId: 0, conversationId: route.params.conversation_id };
      },
    },
  ],
};
